export const LOGOS = {
  crewznation:
    "https://customer-assets.emergentagent.com/job_curated-entry-portal/artifacts/ayr3kktx_Nation_2.PNG",
  rimal:
    "https://customer-assets.emergentagent.com/job_curated-entry-portal/artifacts/wvi6palg_Rimal%20Center%20Logo%20for%20Registration%20purposes%20.jpg",
  rjc: "/logos/rjc.png",
  blurKit: "/logos/blur-kit.png",
  fahrers: "/logos/fahrers.png?v=2",
  a9x: "/logos/a9x.png",
  superFuel:
    "https://customer-assets.emergentagent.com/job_curated-entry-portal/artifacts/uf4l5z0y_8e1c42ce-ab6b-480e-97d4-ae3c6f9a01b1%202.JPG",
  unitedBikers:
    "https://customer-assets.emergentagent.com/job_curated-entry-portal/artifacts/q24zfqrs_47d33a5e-7743-4b31-a94e-dfd620863a38.JPG",
};

export const PARTNERS = [
  // Top row — CrewZNatioN · Rimal Center (host, larger)
  { key: "crewznation", src: LOGOS.crewznation, alt: "CrewZNatioN", invert: false, tier: "primary", scale: 1.3 },
  { key: "rimal", src: LOGOS.rimal, alt: "Rimal Center", invert: true, featured: true, tier: "primary" },
  // Second row — The Fahrers
  { key: "fahrers", src: LOGOS.fahrers, alt: "The Fahrers", invert: false, tier: "secondary" },
];

export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/0ff0422c-8aac-42e0-972b-da9e4cc03c42/images/118ff3e2155dd072df9799f423843df1fdbf21496d7dfbe7d0b3dcb05e01ece6.png";

export const EVENT = {
  // Owner directive (Sep 12, 2026): arrival window is 2:30–5:30 PM;
  // gates close at 6:00 PM; event runs 6:00 PM – 1:00 AM. The former
  // "7:00 PM arrival" copy is retired across all applicant-facing
  // surfaces (email templates, public pass page, funnel steps).
  date: "December 10–12, 2026",
  dateAr: "١٠–١٢ ديسمبر ٢٠٢٦",
  time: "6:00 PM — 1:00 AM",
  arrivalWindow: "2:30 – 5:30 PM",
  gatesClose: "6:00 PM",
  location: "Rimal Center, Riyadh",
  mapUrl: "https://share.google/HwuWYfoE5lJuAa0Xg",
};

// Registration cutoff — Friday, May 1st 2026 at 10:00 PM Riyadh time (UTC+3).
// Stored in UTC (Riyadh = UTC+3, so 22:00 Riyadh on May 1 = 19:00 UTC on May 1).
// Registration deadline is DISABLED (Sept 12, 2026 owner directive):
// the May 1 cutoff is retired; no authoritative replacement date has
// been provided. `null` explicitly means "unset" — do NOT swap in a
// guessed date. `isRegistrationClosed()` returns `false` whenever the
// deadline is null / undefined / not a valid Date. When the owner
// supplies a real cutoff, replace `null` with a `new Date(...)` value
// and this guard automatically re-engages.
export const REGISTRATION_DEADLINE = null;
export const isRegistrationClosed = () => {
  if (REGISTRATION_DEADLINE == null) return false;
  const ts = (REGISTRATION_DEADLINE instanceof Date)
    ? REGISTRATION_DEADLINE.getTime()
    : NaN;
  if (!Number.isFinite(ts)) return false;
  return Date.now() >= ts;
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Applicant club/crew options. Keep `value` stable (English) — it's what gets saved in DB.
// Brand names stay in English on both UIs (these are registered brand names).
// Note (Apr 2026): Independent + Rimal Center are KEPT here for applicants to choose from,
// but the admin portal display logic (_display_group_admin / _display_group_email on the
// backend) maps both of those values to "CrewZNatioN" for internal tracking, CSVs, and
// emails. Their original choice is still preserved in the database.
export const CLUB_OPTIONS = [
  { value: "CrewZNatioN", en: "CrewZNatioN", ar: "CrewZNatioN" },
  { value: "Rimal Center", en: "Rimal Center", ar: "Rimal Center" },
  { value: "The Fahrers", en: "The Fahrers", ar: "The Fahrers" },
  { value: "Independent", en: "Independent / Other", ar: "مستقل / أخرى" },
];
